module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_library.js
// module id = 72
// module chunks = 47